// extracted by mini-css-extract-plugin
module.exports = {"trustpilotWidgetContainer":"trustpilot-widget_trustpilotWidgetContainer__1N4RU","linkOverlay":"trustpilot-widget_linkOverlay__SGS_T"};